export default __webpack_public_path__ + "static/media/CB_6192.a695ca96.jpg";